import SearchPeriodsController from "./controller";
import searchPeriodsComponents from "./components/module";
import SearchPrioritizeFactory from "./factory";
// import SearchService from "./service";

const modul = angular
    .module("searchPeriods", [searchPeriodsComponents])

    .controller("SearchPeriodsController", SearchPeriodsController)

    // .service("searchService", SearchService)
    .factory("SearchPrioritizeFactory", SearchPrioritizeFactory);

export default modul.name;
